export default {
  props: {
    caretPosition: {
      type: String,
      default: 'right',
    },
    caretBottom: {
      type: Boolean,
      default: false,
    },
    caretPointsTo: {
      type: String,
      validator: (prop) => ['top', 'right', 'bottom', 'left'].includes(prop),
    },
    caretOffset: {
      type: Number,
      default: 0,
    },
    customCaretClassName: {
      type: String,
      default: '',
    },
    delay: {
      type: Number,
      default: 500,
    },
    eventLocation: {
      type: String,
      default: '',
    },
    header: {
      required: true,
      type: String,
      default: '',
    },
    intro: {
      type: String,
      default: '',
    },
    localStorageKey: {
      type: String,
      default: '',
    },
    mainActionLink: {
      type: String,
      default: '',
    },
    mainActionText: {
      type: String,
      default: 'check it out',
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    showDismiss: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'informational',
    },
  },
};
